import { NgModule } from '@angular/core';
import { CalendarViewHourDisplayPipe } from './calendarViewHourDisplay.pipe';

@NgModule({
  declarations: [CalendarViewHourDisplayPipe],
  exports: [CalendarViewHourDisplayPipe],
})
export class CalendarViewHourDisplayPipeModule {}
